const mapStateToProps = (state) => {
    return{ 
        stateProps : {
            firstNumber: state.firstNumber,
            secondNumber: state.secondNumber,
            firstOpuest: state.firstOpuest,
            secondOpuest: state.secondOpuest,
            comma: state.comma,
            operation: state.operation,
            result: state.result,
            history: state.history,
            screenInitial: state.screenInitial,
            screenStop: state.screenStop,  
        }
    }
}

export default mapStateToProps;